<template>
    <div>
        <navigation :label="ts( 'pageNotFound' )" />

        <div class="row window-height-90 full-width items-center justify-center">
            <div class="column full-width-90">
                <q-img :src="notFoundImg" fill no-native-menu>
                    <div class="absolute-bottom text-subtitle1 text-center">
                        {{ ts( 'noPageFound' ) }}
                    </div>
                </q-img>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
// Purpose: handle 404

import notFoundImg from '@/assets/notfound.webp'

import { ts } from '@/plugins/i18n-formatted'
import Navigation from "@/components/parts/navigation.vue";
</script>

<style lang="sass" scoped>
.full-width-90
  width: 90vh !important
  margin-left: 0 !important
  margin-right: 0 !important

.window-height-90
  margin-top: 0 !important
  margin-bottom: 0 !important
  height: 90vh !important
</style>